module.exports = __webpack_public_path__ + "./images/43931c7e2030c965c5dc47f6434b3cf9.webp";